module.exports = __webpack_public_path__ + "img/logo2.ff1b22a8.png";